function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58545 2.00024L7.99966 0.586029L19.4134 11.9998L7.99966 23.4135L6.58545 21.9993L16.5847 12.0003L6.58545 2.00024Z",
    fill: "currentColor"
  }));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BlackHorseIcon = function BlackHorseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 12.0015L7.44428 24L6 22.5L16.11 12L6.00001 1.50002L7.44431 -6.31327e-08L19 12.0015Z",
    fill: "currentColor"
  }));
};
BlackHorseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0L4 4.83365L13.8772 12L4 19.1663L4 24L21 12.0461L4 0Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58545 2.00024L7.99966 0.586029L19.4134 11.9998L7.99966 23.4135L6.58545 21.9993L16.5847 12.0003L6.58545 2.00024Z",
    fill: "currentColor"
  }));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.53227 23.5757L19 12.0073L7.53227 0.43888C6.95219 -0.146293 6.01514 -0.146293 5.43506 0.43888C4.85498 1.02405 4.85498 1.96934 5.43506 2.55451L14.7907 11.9923L5.43506 21.4301C4.85498 22.0153 4.85498 22.9605 5.43506 23.5457C6.02152 24.1373 6.92776 24.155 7.53227 23.5757Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4L16 12L8 20L12 24L24 12L12 0L8 4Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5556 11.9967L7.05774 20.9678C6.41667 21.6446 6.41017 22.7771 7.0691 23.4727C7.73127 24.1735 8.78944 24.1735 9.44187 23.4864L18.9443 13.4547C19.3079 13.0692 19.4669 12.5381 19.4166 12.0224C19.4848 11.4947 19.3273 10.943 18.9443 10.5403L9.44187 0.508653C8.8008 -0.168121 7.72802 -0.174974 7.0691 0.520647C6.40531 1.21969 6.40531 2.3368 7.05774 3.02557L15.5556 11.9967Z",
    fill: "currentColor"
  }));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4323 0.435472C6.00871 -0.145157 6.94324 -0.145157 7.51964 0.435473L19 12L7.51964 23.5645C6.94324 24.1452 6.00871 24.1452 5.4323 23.5645C4.8559 22.9839 4.8559 22.0425 5.4323 21.4619L14.8253 12L5.4323 2.53811C4.8559 1.95749 4.8559 1.0161 5.4323 0.435472Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BLACK_HORSE, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT, BOS, HALIFAX, LLOYDS2023, MBNA, SCOTTISH_WIDOWS } from "../../constants";
export default function ChevronRight(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.chevron_right) {
    svg = theme.assets.icons.chevron_right;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BLACK_HORSE:
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = BlackHorseIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      default:
        console.warn("Icon \"ChevronRight\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}